import { UploadFile } from "antd";

/**
 * 获取文件名
 * @param url
 * @returns
 */
export function getFileName(url: string) {
  const urlObj = new URL(url);
  const filename = urlObj.pathname.split("/").pop();
  return decodeURIComponent(filename!);
}

/**
 * 获取文件名后缀
 * @param str
 * @returns
 */
function getExtname(str: string) {
  var slug = str.split(/\/|\\/).slice(-1)[0];
  var idx = slug.lastIndexOf(".");
  if (idx <= 0) return "";
  var ext = slug.slice(idx);
  return ext;
}

/**
 * 是否是图片
 * @param url
 * @returns
 */
export const isImage = (url: string) => {
  const ext = getExtname(url);

  if (ext === ".png" || ext === ".jpeg") return true;
  return false;
};

/**
 * 是否是视频
 * @param url
 * @returns
 */
export const isVideo = (url: string) => {
  const ext = getExtname(url);

  if (ext === ".mp4") return true;
  return false;
};

/**
 * 是否允许预览文件
 * @param url
 * @returns
 */
export const isPreviewAllowed = (url: string) => {
  const allowedFileExts = [
    ".jpg",
    ".jpeg",
    ".png",
    ".docx",
    ".doc",
    ".xslx",
    ".mp4",
    ".pptx",
    ".pdf",
  ];

  const ext = getExtname(url);
  if (allowedFileExts.includes(ext)) return true;

  return false;
};

export const convertFileItems = (url?: string) => {
  if (!url) return [];

  return url.split(",").map((item) => {
    return {
      url: item,
      name: getFileName(item),
    };
  });
};

// 转换文件项为字符串
export const convertFileItemsToString = (files?: UploadFile[] | null) => {
  if (!files || files.length === 0) return null;

  const filePaths = files.map((file) => file.url).join(",");
  return filePaths;
};

export function mapFilesByType(
  files: Array<{ fileType: string; fileUrl: string; id: number }>,
  targetType: string,
): UploadFile[] {
  return files
    .filter((f) => f.fileType === targetType)
    .map((f) => ({
      uid: f.id.toString(),
      name: getFileName(f.fileUrl),
      url: f.fileUrl,
    }));
}

/** 从Content-Disposition头中提取文件名 */
export function getFilenameFromContentDisposition(disposition: string) {
  let filename = "";

  if (disposition && disposition.includes("filename*=")) {
    // RFC 5987 编码的文件名
    filename = disposition
      .substring(disposition.indexOf("filename*=") + 10)
      .trim();
    filename = decodeURIComponent(filename);
  } else if (disposition && disposition.includes("filename=")) {
    // 普通文件名
    filename = disposition
      .substring(disposition.indexOf("filename=") + 9)
      .trim();
    // 移除可能存在的引号
    if (filename.startsWith('"') && filename.endsWith('"')) {
      filename = filename.slice(1, -1);
    }
  }

  return filename;
}
